/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { PersonAgreeDTO } from "../model";
import { PersonAgreeDTOTrackedI, PersonAgreeDTOMeta } from "../model";
// @ts-ignore
import type { PersonAgreementsDTO } from "../model";
import { PersonAgreementsDTOTrackedI, PersonAgreementsDTOMeta } from "../model";
// @ts-ignore
import type { PersonAgreementsInternalDTO } from "../model";
import {
  PersonAgreementsInternalDTOTrackedI,
  PersonAgreementsInternalDTOMeta,
} from "../model";
// @ts-ignore
import type { RequiredAgreementsDTO } from "../model";
import {
  RequiredAgreementsDTOTrackedI,
  RequiredAgreementsDTOMeta,
} from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * AgreementApi - axios parameter creator
 * @export
 */
export const AgreementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Posts an agreement
     * @param {PersonAgreeDTO} personAgreeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberAgreementsPost: (
      personAgreeDTO: PersonAgreeDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personAgreeDTO' is not null or undefined
      assertParamExists(
        "memberAgreementsPost",
        "personAgreeDTO",
        personAgreeDTO,
      );
      const localVarPath = `/member/agreements`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        personAgreeDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets current agreements
     * @param {RequiredAgreementsDTO} requiredAgreementsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRequiredAgreementsPost: (
      requiredAgreementsDTO: RequiredAgreementsDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'requiredAgreementsDTO' is not null or undefined
      assertParamExists(
        "memberRequiredAgreementsPost",
        "requiredAgreementsDTO",
        requiredAgreementsDTO,
      );
      const localVarPath = `/member/requiredAgreements`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requiredAgreementsDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gets required agreements for current open order
     * @param {number} personId The person ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffAgreementsPersonIdGet: (
      personId: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists("staffAgreementsPersonIdGet", "personId", personId);
      const localVarPath = `/staff/agreements/{personId}`.replace(
        `{${"personId"}}`,
        encodeURIComponent(String(personId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type memberAgreementsPostParams = { personAgreeDTO: PersonAgreeDTO };
export type memberRequiredAgreementsPostParams = {
  requiredAgreementsDTO: RequiredAgreementsDTO;
};
export type staffAgreementsPersonIdGetParams = { personId: number };

export const memberAgreementsPostMeta = {
  personAgreeDTO: propertyMeta(
    "personAgreeDTO",
    false,
    true,
    false,
    PersonAgreeDTOMeta,
  ),
};
export const memberRequiredAgreementsPostMeta = {
  requiredAgreementsDTO: propertyMeta(
    "requiredAgreementsDTO",
    false,
    true,
    false,
    RequiredAgreementsDTOMeta,
  ),
};
export const staffAgreementsPersonIdGetMeta = {
  personId: propertyMeta("personId", false, true, false, MetaTypesBase.number),
};

/**
 * AgreementApi - functional programming interface
 * @export
 */
export const useAgreementApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AgreementApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Posts an agreement
     * @param {PersonAgreeDTO} personAgreeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberAgreementsPostRaw(
      props: memberAgreementsPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberAgreementsPost(
        props.personAgreeDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AgreementApi.memberAgreementsPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonAgreementsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets current agreements
     * @param {RequiredAgreementsDTO} requiredAgreementsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRequiredAgreementsPostRaw(
      props: memberRequiredAgreementsPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberRequiredAgreementsPost(
          props.requiredAgreementsDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AgreementApi.memberRequiredAgreementsPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonAgreementsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets required agreements for current open order
     * @param {number} personId The person ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffAgreementsPersonIdGetRaw(
      props: staffAgreementsPersonIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsInternalDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffAgreementsPersonIdGet(
          props.personId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AgreementApi.staffAgreementsPersonIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonAgreementsInternalDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsInternalDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Posts an agreement
     * @param {PersonAgreeDTO} personAgreeDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberAgreementsPost(
      personAgreeDTO: PersonAgreeDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberAgreementsPost(
        personAgreeDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AgreementApi.memberAgreementsPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonAgreementsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets current agreements
     * @param {RequiredAgreementsDTO} requiredAgreementsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRequiredAgreementsPost(
      requiredAgreementsDTO: RequiredAgreementsDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberRequiredAgreementsPost(
          requiredAgreementsDTO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AgreementApi.memberRequiredAgreementsPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonAgreementsDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Gets required agreements for current open order
     * @param {number} personId The person ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffAgreementsPersonIdGet(
      personId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonAgreementsInternalDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffAgreementsPersonIdGet(personId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AgreementApi.staffAgreementsPersonIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonAgreementsInternalDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonAgreementsInternalDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * AgreementApi - interface
 * @export
 * @interface AgreementApi
 */
export interface AgreementApiInterface {
  /**
   * Posts an agreement
   * @param {PersonAgreeDTO} personAgreeDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementApiInterface
   */
  memberAgreementsPost(
    personAgreeDTO: PersonAgreeDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonAgreementsDTO>;

  /**
   * Gets current agreements
   * @param {RequiredAgreementsDTO} requiredAgreementsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementApiInterface
   */
  memberRequiredAgreementsPost(
    requiredAgreementsDTO: RequiredAgreementsDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonAgreementsDTO>;

  /**
   * Gets required agreements for current open order
   * @param {number} personId The person ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgreementApiInterface
   */
  staffAgreementsPersonIdGet(
    personId: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonAgreementsInternalDTO>;
}
